import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'
import listenToSelector from '../util/listen_to_selector'

// Toggles whether top level nav should be visible or not
export default function NavDispatcher () {
  const { role } = store.getState()[appSlice.name]

  if (['presenter', 'slideware', 'agave'].includes(role)) {
    // Show L1 nav only when logged in
    const loggedIn = appSlice.selectIsFullyLoggedIn(store.getState())
    store.dispatch(appSlice.toggledL1(loggedIn))

    listenToSelector((state) => appSlice.selectIsFullyLoggedIn(state), (loggedIn) => {
      store.dispatch(appSlice.toggledL1(loggedIn))
    })
  } else if (role === 'participant') {
    // anonymous usage allowed
    store.dispatch(appSlice.toggledL1(true))
  } else {
    // all else should hide l1
    store.dispatch(appSlice.toggledL1(false))
  }
}
